// TAppState берём из redux/types, а НЕ из барреля redux/index: тот ре-экспортит
// ./store, который создаёт стор и запускает саги на уровне модуля. Сейчас ни один
// тест стор не импортирует, и это свойство стоит сохранить.
import { TEntityRef } from '@ws/shared/types';

import { TAppState } from '../../redux/types';

import { EDITOR_LAYOUT_VERSION, TEditorLayout } from './editorLayout.types';

/**
 * Обрезает ссылку до {id, type}.
 *
 * Типы обещают `TEntityRef`, но часть вызывающих кладёт в стор целый узел: структурная
 * типизация это пропускает, потому что `TNote` удовлетворяет `TEntityRef`. Без обрезки
 * в localStorage уезжало бы тело заметки — лишние килобайты и устаревшая копия
 * содержимого рядом с настройками окон.
 */
const toRef = (ref: TEntityRef | null): TEntityRef | null =>
  ref ? { id: ref.id, type: ref.type } : null;

/**
 * Собирает срез layout'а из стора. `null`, если проекта нет — сохранять нечего.
 *
 * При добавлении поля в `TEditorLayout` правка нужна и здесь, и в списке наблюдаемых
 * ссылок подписки: иначе поле либо не попадёт в срез, либо попадёт, но никогда не
 * вызовет запись само по себе.
 */
export function collectLayout(state: TAppState): TEditorLayout | null {
  const { project, selected, secondarySelected } = state.editor;

  if (!project) {
    return null;
  }

  return {
    v: EDITOR_LAYOUT_VERSION,
    savedAt: Date.now(),
    selected: toRef(selected),
    secondarySelected: toRef(secondarySelected),
    isCompiled: state.general.isCompiled,
    isSecondaryCompiled: state.general.isSecondaryCompiled,
    contentWindows: {
      list: [...state.contentWindows.list],
      settings: { ...state.contentWindows.settings },
    },
  };
}
